import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback } from 'react';
import { axiosBeelineRequest, noop } from '@beef/utils';
import { composeEmailValidator } from '@beef/utils/validators';
import { decorateHandler } from "../../../metric";
var onMetricFulfilled = function onMetricFulfilled() {
  decorateHandler(noop, {
    footerMetric: ['onSubscribeEmail']
  })();
};

/* FIXME: пе-ре-пи-ши-те меня */
export var useSubmitHandler = function useSubmitHandler(_ref) {
  var email = _ref.email,
    enterEmail = _ref.enterEmail,
    invalidEmail = _ref.invalidEmail,
    setRequestStatus = _ref.setRequestStatus,
    setErrorText = _ref.setErrorText,
    backendUrl = _ref.backendUrl,
    setAnimate = _ref.setAnimate,
    iconRef = _ref.iconRef;
  return useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      var animationEndHandler;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            event.preventDefault();
            if (email.trim().length) {
              _context.next = 4;
              break;
            }
            setErrorText(enterEmail);
            return _context.abrupt("return");
          case 4:
            if (!composeEmailValidator('fail')(email)) {
              _context.next = 7;
              break;
            }
            setErrorText(invalidEmail);
            return _context.abrupt("return");
          case 7:
            animationEndHandler = function animationEndHandler() {
              setRequestStatus('success');
              setAnimate(false);
              if (iconRef.current) {
                iconRef.current.removeEventListener('animationend', animationEndHandler);
              }
            };
            setErrorText('');
            setRequestStatus('processing');
            _context.prev = 10;
            _context.next = 13;
            return subscribeMailList({
              email: email,
              url: backendUrl,
              onSuccess: function onSuccess() {
                onMetricFulfilled();
                setAnimate(true);
                if (iconRef.current) {
                  iconRef.current.addEventListener('animationend', animationEndHandler);
                } else {
                  setRequestStatus('success');
                  setAnimate(false);
                }
              },
              onError: function onError(error) {
                setErrorText(error || 'Ошибка');
                setRequestStatus('error');
                setAnimate(false);
              }
            });
          case 13:
            _context.next = 19;
            break;
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](10);
            setErrorText('Неизвестная ошибка');
            setRequestStatus('error');
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[10, 15]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [email, enterEmail, invalidEmail, setRequestStatus, setErrorText, backendUrl, setAnimate]);
};

/* FIXME: o_0, меня тоже пе-ре-пи-ши-те */
var subscribeMailList = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var email, url, onSuccess, onError, formData, requestData, _response$Data, response, _response$Data$Error;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          email = _ref3.email, url = _ref3.url, onSuccess = _ref3.onSuccess, onError = _ref3.onError;
          formData = new FormData();
          requestData = {
            subscriber: {
              email: email,
              data_source: window.location.href,
              subscribe: true
            }
          };
          formData.append('json', JSON.stringify(requestData));
          _context2.prev = 4;
          _context2.next = 7;
          return axiosBeelineRequest({
            url: url,
            data: formData,
            method: 'post'
          });
        case 7:
          response = _context2.sent;
          if (!((_response$Data = response.Data) !== null && _response$Data !== void 0 && _response$Data.Success && onSuccess)) {
            _context2.next = 11;
            break;
          }
          onSuccess(response.Data);
          return _context2.abrupt("return", true);
        case 11:
          if (onError) {
            onError((_response$Data$Error = response.Data.Error) === null || _response$Data$Error === void 0 ? void 0 : _response$Data$Error.Message);
          }
          return _context2.abrupt("return", false);
        case 15:
          _context2.prev = 15;
          _context2.t0 = _context2["catch"](4);
          console.error(_context2.t0);
          if (onError) {
            onError();
          }
          return _context2.abrupt("return", false);
        case 20:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[4, 15]]);
  }));
  return function subscribeMailList(_x2) {
    return _ref4.apply(this, arguments);
  };
}();